<template>
	<div class="learner_profile_resume" aria-label="Learner Profile Resume Page">

		<div class="card crd_sty_3">

			<div class="row pg_sec_head align-items-center">
				<div class="col">
					<div class="hd_txt">
						{{ $t('resumeAndPortfolio') }}
					</div>
				</div>
				<div class="col-auto text-right">
					<template v-if="resume && resume.uploadedVersions.length > 0">
						<button class="btn" @click="chooseFile">
							{{ $t('uploadResume') }}
						</button>
					</template>
					<template v-else>
						<button class="btn" @click="chooseFile">
							{{ $t('uploadResume') }}
						</button>
					</template>
						<button type="button" class="btn align-middle ml-2" @click="openResumeBuilder" :disabled="userRole !== 'Student'">
							{{ $t('startResumeBuilder') }}
						</button>
					  <span class="visibility-btn icon-eye" @click="requestVisibilityModal('Resume', false)" v-if="currentProfile.resumeVisibleToEmployer" title="Visible to Employer">
            </span>
            <span class="visibility-btn icon-eye-blocked" @click="requestVisibilityModal('Resume', true)" v-else title="Not Visible to Employer">
            </span>	
					<div class="hidden-container mt-3" style="display: none; height: 0px; width: 0; margin: 0; padding: 0; overflow: hidden;">	
						<form method="POST" id="resumeUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
							<input type="file" id="resumeFile" name="file" ref="fileInput" @change="fileToBeUploaded" />
						</form>
					</div>
				</div>
			</div>

			<div class="row pg_sec_content mr-0 pr-0">

				<div class="col-12 section_content mr-0 pr-0">
					<template v-if="primaryResume">
						<div class="row sec_col" v-for="version in resume.uploadedVersions">
							<div class="col-1 col_radio">
								<input type="radio" :id="version.id" :value="version.id" v-model="primaryResumeId" @change="changePrimary($event)" style="cursor: pointer;">
							</div>
							<div class="col-1 ic_container_bx">
								<div class="ic ic9-job1"></div>
							</div>
							<div class="col-8 col_name">
								<span>{{version.fileName}}</span>
							</div>
							<!--
							<div class="col-3">
								<span>{{version.uploadedBy}}</span>
							</div>
							-->
							<div class="col-3 col_date">
								<span>{{changeMillisToDate(version.uploadedAt)}}</span>
							</div>
							<div class="col-1 col_action">
								<button 
									class="btn btn_ic" 
									@click="download(version)"
									:aria-label="$t('downloadResumeAria')"
									:title="$t('downloadResumeTitle')"
									v-b-tooltip.hover>
									<span class="fa fa-download" aria-hidden="true"></span>
								</button>
								<button 
								class="btn btn_ic" 
								@click="showDeleteProfileResume(version)"
								:aria-label="$t('deleteResumeAria')"
								:title="$t('deleteResumeTitle')"
								v-b-tooltip.hover>
									<span class="ic_btn icon-bin"></span>
								</button>
							</div>
						</div>
			</template>
			<template v-else>
				<div class="row fld_row">
							<div class="col-12 head_msg text-center">
								<h5>{{ $t('noResumeUploaded') }}</h5>
							</div>
						</div>
			</template>

			<div class="loading-spinner">
				<b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
					<div class="text-center" style="color: #FFF; overflow: hidden;">
					<i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
					</div>
				</b-modal>
				</div>

				</div>

				<div class="col-12">
					<template v-if="!primaryResume">
						<div class="col-10 resume_detail_sec inactive">
							<span class="mr-2 sub_hd">
								{{ $t('resume') }}
							</span>
							<span class="mr-2 no_file">
								<small>
									-- {{ $t('noResumeUploaded') }} --
								</small>
							</span>
							<!--
							<span class="ic_container">
								<span class="ic fa fa-download" aria-hidden="true"></span>
							</span>
							-->
						</div>
					</template>
				</div>
			</div>

		</div>

		<b-modal class="h-100 d-inline-block" id="learner-profile-resume-popup" ref="profileResumeModal" size="xl" :header-bg-variant="'profile-popup-header'" hide-footer no-close-on-backdrop no-close-on-esc centered>
			<div slot="modal-header" class="header-section w-100">
        <div class="profile_popup_head_txt float-left">
          <span>{{ $t('uploadedResumes') }}</span>
        </div>
        <div class="float-right">
          <button
					 	@click="cancelProfileResumeModal"
						class="btn_close"
						:aria-label="$t('closeAria')"
						:title="$t('closeTitle')"
						v-b-tooltip.hover>
            	<span class="ic-close"></span>
          </button>
        </div>
        <div class="float-right mr-4" v-if="resume && resume.uploadedVersions.length > 1">
          <b-button @click="saveProfileResume">{{ $t('save') }}</b-button>
        </div>
      </div>

			<div class="modal_content">
				<template v-if="resume && resume.uploadedVersions.length > 0">
					<div class="row fld_row">
						<div class="col-8">
							<template v-if="resume && resume.uploadedVersions.length > 1">
								<span>{{ $t('makePrimaryByClickingRadioButton') }}</span>
							</template>
						</div>
						<div class="col-4 btn_container upload_resume">
							<button @click="chooseFile">
								<i class="fa fa-upload" aria-hidden="true"></i> {{ $t('uploadResume') }}
							</button>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="row fld_row">
						<div class="col-12 btn_container upload_resume_lg">
							<button @click="chooseFile">
								<i class="fa fa-upload" aria-hidden="true"></i> {{ $t('uploadResume') }}
							</button>
						</div>
					</div>
				</template>
				<template v-if="primaryResume">
					<div class="row fld_row" v-for="version in resume.uploadedVersions">
						<div class="col-4">
							<input type="radio" :id="version.id" :value="version.id" v-model="primaryResumeId" @change="changePrimary($event)" style="cursor: pointer;">
							<span>{{version.fileName}}</span>
						</div>
						<div class="col-3">
							<span>{{version.uploadedBy}}</span>
						</div>
						<div class="col-3">
							<span>{{changeMillisToDate(version.uploadedAt)}}</span>
						</div>
						<div class="col-2">
							<span v-if="version.primary"><small>{{ $t('primary') }}</small></span>
							<span v-else> </span>
							<b-link @click="download(version)">
								<span class="fa fa-download" aria-hidden="true"></span>
							</b-link>
							<b-link @click="showDeleteProfileResume(version)">
								<span class="ic_btn icon-bin"></span>
							</b-link>
						</div>
					</div>
	      </template>
	      <template v-else>
	      	<div class="row fld_row">
						<div class="col-12 head_msg text-center">
							<h5>{{ $t('noResumeUploaded') }}</h5>
						</div>
					</div>
	      </template>

	      <div class="loading-spinner">
		      <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
		        <div class="text-center" style="color: #FFF; overflow: hidden;">
		          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
		        </div>
		      </b-modal>
		    </div>

			</div>
		</b-modal>

	<div>
      <b-modal ref="changePrimaryResumeModal" :header-bg-variant="'profile-popup-header'" :title="$t('update')" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>{{ $t('confirmChangePrimaryResumeMsg') }}</h6>
        </div>
        <div slot="modal-footer" class="w-100" style="text-align: right;">
			<template v-if="resume && resume.uploadedVersions.length > 1">
          		<b-button @click="saveProfileResume">{{ $t('ok') }}</b-button>
			</template>	
			<!--
          		<b-link class="float-right mr-4 mt-1" @click="cancelChangePrimaryResumeModal">{{ $t('cancel') }}</b-link>
			-->
        </div>
      </b-modal>
    </div>

	<div>
      <b-modal ref="deleteProfileResumeModal" :header-bg-variant="'profile-popup-header'" :title="$t('pleaseConfirm')" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>{{ $t('confirmDeleteResumeMsg') }}</h6>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteProfileResume" class="btn button-primary float-right mr-2">{{ $t('yes') }}</b-button>
          <b-link class="float-right mr-4 mt-1" @click="cancelDeleteProfileResume">{{ $t('noDoNotDelete') }}</b-link>
        </div>
      </b-modal>
    </div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { DateTime } from 'luxon'
	import { mapState, mapActions } from 'vuex'
	import { AwsObject } from '../../learningContent/aws'

  var isValidFile = function (file) {
    let fileName = file.name
    let pdfRegEx = /(.pdf)$/i
    let docRegEx = /(.doc)$/i
    let docxRegEx = /(.docx)$/i
    return pdfRegEx.test(fileName) || docRegEx.test(fileName) || docxRegEx.test(fileName)
  }

  var getFileName = function (fileName) {
	  if (!fileName && fileName !== null) {
	    return null
	  }
	  return fileName.replace(/\.\w+$/g, '')
	}

  var getUpdatedFileName = function (title, fileName) {
	  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
	  if (ext !== '' || ext !== null) {
	    return (title + '.' + ext)
	  } else {
	    return fileName
	  }
	}

	var FileObject = function (title, file, size, timestamp, type) {
	  this.title = getFileName(title)
	  this.file = file
	  this.fileName = getUpdatedFileName(this.title, title)
	  this.size = size
	  this.contentFileType = type
	  this.timestamp = timestamp
	}

	export default {
		name: 'learner-profile-resume',
		props: ['uuid'],
		data: () => {
			return {
				file: undefined,
				userObject: undefined,
				primaryResumeId: undefined,
				selectedToDelete: undefined
			}
		},
		computed: {
			...mapState({
        'currentEnvironment': state => state.learningContent.currentEnvironment,
        'userRole': state => state.user.userRole
      }),
	  resume () {
      	if (this.userObject && this.userObject.userProfile) {
      		return this.userObject.userProfile.resume
      	}
      	return null
      },
	  currentProfile () {
      	if (this.userObject && this.userObject.userProfile) {
      		return this.userObject.userProfile
      	}
      	return {}
      },
	  isResumeBuilderEnabled () {
        let resumeBuilder = this.enabledFeatures['Resume Builder']
        return resumeBuilder && resumeBuilder.enabled
      },
      primaryResume () {
      	if (this.resume) {
      		let resumes = this.resume.uploadedVersions
      		return _.find(resumes, (resume) => {
            return resume.primary
          })
      	}
      	return null
      }
		},
		async created () {
			this.userObject = await this.loadUser(this.uuid)

			if (this.primaryResume) {
    			this.primaryResumeId = this.primaryResume.id
  			}
		},
		mounted () {
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
    },
    methods: {
			...mapActions([
				'loadUser',
        'loadCurrentEnvironment',
        'loadUpdateProfileResume',
        'loadDeleteProfileResume',
        'loadUpdateProfileResumeAsPrimary',
        'getAIServerConnectionInfo'
	    ]),
	    showLoader () {
	      if (this.$refs.loadingModal) {
	        this.$refs.loadingModal.doShow()
	      }
	    },
	    requestVisibilityModal (attributeName, attributeValue) {
	      this.$emit('show-visibility-modal', attributeName, attributeValue)
	    },
	    hideLoader () {
	      if (this.$refs.loadingModal) {
	        this.$refs.loadingModal.hide()
	      }
	    },
	    showProfileResumeModal () {
	    	if (this.primaryResume) {
					this.primaryResumeId = this.primaryResume.id
				}
				this.$refs.profileResumeModal.show()
			},
			async openResumeBuilder() {
				const connectionInfo = await this.getAIServerConnectionInfo();
				const base = String(connectionInfo.uri || "").replace(/\/+$/, "");
				const token = connectionInfo.token;

				if (!base || !token) {
					console.warn("Missing Pragya URI or token");
					return;
				}

				const ssoUrl = `${base}/#/sso/consume?token=${encodeURIComponent(
					token
				)}&resource=resume`;

				const child = window.open(ssoUrl, "_blank", "noopener,noreferrer");
				if (!child) {
					// popup blocked
					return;
				}
				},
			clearFilePath () {
	      const input = this.$refs.fileInput
        input.type = 'text'
        input.type = 'file'
	    },
			chooseFile () {
				let sel = 'id=resumeFile'
        $('input[type=file][' + sel + ']').click()
			},
			fileToBeUploaded (ev) {
        let files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.file = files[0]
        if (isValidFile(this.file)) {
        	let size = this.file.size
        	if (Math.abs(size/5242880) <= 1) {
        		this.showLoader()
	        	let timestamp = new Date().getTime()
	          let fileData = new FileObject(this.file.name, this.file, size, timestamp, this.file.type)
	          let id = this.uuid + '-' + timestamp
	          let key = id + '-' + fileData.fileName
	          this.storeFilesToS3({id: id, key: key, fileData: fileData})
        	} else {
        		this.hideLoader()
        		this.clearFilePath()
        		this.$notify({
	            group: 'notify',
	            type: 'error',
	            title: '',
	            text: this.$t('fileSizeExceedsLimit')
	          })
        	}
        } else {
          this.clearFilePath()
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.$t('unsupportedFileType')
          })
        }
      },
      storeFilesToS3 (item) {
      	let s3AwsRef = new AWS.S3()
        let s3Bucket = this.currentEnvironment.s3Bucket
        let fileName = item.fileData.fileName
        var params = {
          Key: item.key,
          Bucket: s3Bucket,
          ContentType: item.fileData.contentFileType,
          ACL: 'public-read',
          Body: item.fileData.file,
          ContentDisposition: 'attachment; filename="' + fileName + '"'
        }
        s3AwsRef.putObject(params, (err, data) => {
          if (err) {
          	this.clearFilePath()
            this.hideLoader()
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: '<strong>"' + fileName + '" ' + this.$t('failedToUpload') + '.</strong>'
            })
          } else {
          	let uploadedVersions = []
	          let fileUrl = 'https://'.concat(s3Bucket).concat('.s3-us-west-2.amazonaws.com/').concat(item.key).concat('?versionId=' + data.VersionId)
	          if (this.resume) {
	          	uploadedVersions = this.resume.uploadedVersions
	          }
	          let resume = {
	          	latestVersion: {
	          		id: item.id,
	          		key: item.key,
	          		primary: true,
	          		fileUrl: fileUrl,
	          		fileName: fileName
	          	},
	          	uploadedVersions: uploadedVersions
	          }
	          this.loadUpdateProfileResume({uuid: this.uuid, resume: resume}).then(userProfile => {
	          	this.userObject.userProfile = userProfile
	          	if (this.primaryResume) {
	          		this.primaryResumeId = this.primaryResume.id
	          	}
	          	this.hideLoader()
	          	this.clearFilePath()
	          	this.$notify({
		            group: 'notify',
		            type: 'success',
		            title: '',
		            text: '<strong>"' + fileName + '" ' + this.$t('uploadedSuccessfully') + '.</strong>'
		          })
	          })
          }
        })
      },
      download (currentVersion) {
      	let path = currentVersion.fileUrl
      	let filename = currentVersion.fileName
      	const anchor = document.createElement('a')
		    anchor.href = path
		    anchor.download = filename
		    document.body.appendChild(anchor)
		    anchor.click()
		    document.body.removeChild(anchor)
      },
      changePrimary (ev) {
		this.$refs.changePrimaryResumeModal.show()
      	this.primaryResumeId = ev.target.value
      },
      saveProfileResume () {
      	this.loadUpdateProfileResumeAsPrimary({uuid: this.uuid, id: this.primaryResumeId}).then(userProfile => {
      		this.userObject.userProfile = userProfile
      		//this.cancelProfileResumeModal()
			this.$refs.changePrimaryResumeModal.hide()
      	})
      },
	  cancelChangePrimaryResumeModal () {
		this.$refs.changePrimaryResumeModal.hide()
	  },
      showDeleteProfileResume (selected) {
      	this.selectedToDelete = selected
      	this.$refs.deleteProfileResumeModal.doShow()
      },
      deleteProfileResume () {
      	let s3AwsRef = new AWS.S3()
        let s3Bucket = this.currentEnvironment.s3Bucket
        let id = this.selectedToDelete.id
        let key = this.selectedToDelete.key
        let fileName = this.selectedToDelete.fileName
        var params = {
          Key: key,
          Bucket: s3Bucket
        }
        this.cancelDeleteProfileResume()
        this.showLoader()
        s3AwsRef.deleteObject(params, (err, data) => {
				  if (err) {
				  	this.hideLoader()
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: '<strong>"' + fileName + '" ' + this.$t('failedToDelete') + '.</strong>'
            })
          } else {
          	this.loadDeleteProfileResume({uuid: this.uuid, id: id}).then(userProfile => {
		      		this.userObject.userProfile = userProfile
		      		if (this.primaryResume) {
		      			this.primaryResumeId = this.primaryResume.id
		      		}
		      		this.hideLoader()
		      		this.$notify({
		            group: 'notify',
		            type: 'success',
		            title: '',
		            text: '<strong>"' + fileName + '" ' + this.$t('deletedSuccessfully') + '.</strong>'
		          })
		        })
          }
				})
      },
      cancelDeleteProfileResume () {
      	this.selectedToDelete = undefined
      	this.$refs.deleteProfileResumeModal.hide()
      },
			cancelProfileResumeModal () {
				this.primaryResumeId = undefined
				this.selectedToDelete = undefined
				this.$refs.profileResumeModal.hide()
			},
			changeMillisToDate (millis) {
        return DateTime.fromMillis(millis).toFormat('h:mm a, MMM dd, yyyy')
      }
	  }
	}
</script>

<style>
  .profile_popup_head_txt {
    font-size: 1.4rem;
    font-weight: 600;
    width: 90%;
  }
  .bg-profile-popup-header {
    background: #eaf8ff !important;
  }

  .learner_profile_resume .visibility-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 28px;
    margin-left: 8px;
    padding: 0;
    border: 1px solid #4f7f3e;
    border-radius: 6px;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    vertical-align: middle;
  }

  .learner_profile_resume .visibility-btn:before {
    margin: 0;
  }

  .learner_profile_resume .visibility-btn:hover,
  .learner_profile_resume .visibility-btn:focus {
    background: #eef5ea;
    color: #4f7f3e;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfileResume.vue